import { gql } from '@apollo/client';

const ADD_FAMILY_WITH_GUARDIAN = gql`
  mutation AddFamilyPlusGuardian(
    $name: String!
    $isActive: Boolean!
    $memberList: [FamilyUserInput!]!
  ) {
    addFamilyUser(
      family: { name: $name, isActive: $isActive }
      familyUsers: { memberList: $memberList }
    ) {
      success
      errors
      family {
        uuid
        name
        isActive
        createdAt
        updatedAt
      }
      familyUsers {
        id
        isActive
        isMinor
        guardianVerified
        hideBilling
        guardianSchedule
        guardianAccount
        familyMessaging
        createdAt
        connectionApproval
        messagingActive
        delegateCommunicationsSettings
        profileImageUrl
        updatedAt
        userCanUpdate
        communityActive
        communityPostActive
        user {
          username
          firstName
          lastName
          profileImageUrl
          avatar
          isActive
          isStaff
          isHost
        }
      }
    }
  }
`;
const INVITE_FAMILY_MEMBERS = gql`
  mutation InviteFamilyUsersMutation(
    $familyInvitations: [FamilyInvitationInput!]
  ) {
    inviteFamilyUsers(familyInvitations: $familyInvitations) {
      success
      errors
      familyInvitations {
        token
        email
        inviteeName
        dateSent
        isRedeemed
        dateRedeemed
        isRejected
        dateExpiration
        isMinor
        connectionApproval
        familyMessaging
        guardianAccountInvite
        guardianSchedule
        hideBilling
        messagingActive
        userCanUpdate
        delegateCommunicationsSettings
        communityActive
        communityPostActive
      }
    }
  }
`;

const FAMILY_INVITATION_RESPONSE = gql`
  mutation RedeemInvitationMutation(
    $token: String!
    $category: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $password1: String!
    $password2: String!
    $username: String!
    $rejectInvitation: Boolean!
    $isHost: Boolean!
  ) {
    redeemUserInvitation(
      category: $category
      token: $token
      register: {
        password1: $password1
        password2: $password2
        firstName: $firstName
        lastName: $lastName
        username: $username
        email: $email
        isHost: $isHost
      }
      rejectInvitation: $rejectInvitation
    ) {
      errors
      success
      sbuUser {
        id
        themePref
        tzPref
        user {
          username
          firstName
          lastName
          isHost
          verified
          profileImageUrl
          isActive
          isStaff
        }
        familySettings {
          messagingActive
          hideBilling
          familyMessaging
          guardianAccount
          isActive
          delegateCommunicationsSettings
          guardianSchedule
          createdAt
          updatedAt
          family {
            uuid
            name
            isActive
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;
const UPDATE_FAMILY = gql`
  mutation UpdateFamilyMutation($isActive: Boolean!, $name: String!) {
    updateFamily(family: { name: $name, isActive: $isActive }) {
      errors
      success
      family {
        uuid
        isActive
        name
        updatedAt
      }
    }
  }
`;
const UPDATE_FAMILY_USER = gql`
  mutation UpdateFamilyUser(
    $connectionApproval: Boolean
    $familyMessaging: Boolean
    $delegateCommunicationsSettings: Boolean
    $familyUuid: ID
    $guardianAccount: Boolean
    $guardianSchedule: Boolean
    $hideBilling: Boolean
    $isActive: Boolean
    $messagingActive: Boolean
    $userCanUpdate: Boolean
    $username: String
    $familyName: String!
    $communityActive: Boolean
    $communityPostActive: Boolean
  ) {
    updateFamilyUser(
      family: { name: $familyName, uuid: $familyUuid, isActive: true }
      familyUser: {
        username: $username
        userCanUpdate: $userCanUpdate
        messagingActive: $messagingActive
        isActive: $isActive
        guardianAccount: $guardianAccount
        guardianSchedule: $guardianSchedule
        hideBilling: $hideBilling
        familyUuid: $familyUuid
        familyMessaging: $familyMessaging
        delegateCommunicationsSettings: $delegateCommunicationsSettings
        connectionApproval: $connectionApproval
        communityActive: $communityActive
        communityPostActive: $communityPostActive
      }
    ) {
      success
      errors
      family {
        uuid
        name
        isActive
        createdAt
        updatedAt
      }
      familyUsers {
        id
        isActive
        hideBilling
        guardianSchedule
        guardianAccount
        familyMessaging
        createdAt
        connectionApproval
        messagingActive
        delegateCommunicationsSettings
        communityActive
        communityPostActive
        profileImageUrl
        updatedAt
        userCanUpdate
        user {
          username
        }
      }
    }
  }
`;
const UPDATE_CHILD_SETTINGS = gql`
  mutation UpdateChildSettings(
    $username: String!
    $id: ID
    $disableMessaging: Boolean
    $doNotContact: Boolean
    $promoFrequency: Int
    $emailOptIn: Boolean
    $emailPrefId: ID
    $phoneOptIn: Boolean
    $phonePrefId: ID
    $promoPhoneOptIn: Boolean
    $promoPushOptIn: Boolean
    $promoSmsOptIn: Boolean
    $pushOptIn: Boolean
    $serviceEmailOptIn: Boolean
    $servicePhoneOptIn: Boolean
    $servicePushOptIn: Boolean
    $serviceSmsOptIn: Boolean
    $smsOptIn: Boolean
    $smsPrefId: ID
    $smsPromoPrefId: ID
    $eventRemindersOptIn: Boolean
  ) {
    updateChildSettings(
      username: $username
      servicePreference: {
        id: $id
        disableMessaging: $disableMessaging
        doNotContact: $doNotContact
        promoFrequency: $promoFrequency
        emailOptIn: $emailOptIn
        emailPrefId: $emailPrefId
        phoneOptIn: $phoneOptIn
        phonePrefId: $phonePrefId
        promoPhoneOptIn: $promoPhoneOptIn
        promoPushOptIn: $promoPushOptIn
        promoSmsOptIn: $promoSmsOptIn
        pushOptIn: $pushOptIn
        serviceEmailOptIn: $serviceEmailOptIn
        servicePhoneOptIn: $servicePhoneOptIn
        servicePushOptIn: $servicePushOptIn
        serviceSmsOptIn: $serviceSmsOptIn
        smsOptIn: $smsOptIn
        smsPrefId: $smsPrefId
        smsPromoPrefId: $smsPromoPrefId
        eventRemindersOptIn: $eventRemindersOptIn
      }
    ) {
      success
      publicKey
      servicePreference {
        id
        doNotContact
        promoFrequency
        disableMessaging
        emailOptIn
        eventRemindersOptIn
        emailPref {
          id
          emailAddress
          isVerified
          isPrimary
          showInDirectory
        }
        emailSubscription {
          id
          status
          confirmedAt
          createdAt
        }
        serviceEmailOptIn
        phoneOptIn
        phonePref {
          id
          phoneNumber
          showInDirectory
          textMeHere
          phoneCategory {
            id
            phoneCategory
          }
        }
        promoPhoneOptIn
        servicePhoneOptIn
        smsOptIn
        serviceSmsOptIn
        promoSmsOptIn
        smsPref {
          id
          phoneNumber
          showInDirectory
          textMeHere
          phoneCategory {
            id
            phoneCategory
          }
        }
        smsPromoPref {
          id
          textMeHere
          showInDirectory
          phoneNumber
          phoneCategory {
            id
            phoneCategory
          }
        }
        promoPushOptIn
        pushOptIn
        servicePushOptIn
      }
    }
  }
`;
const GRANT_PARENTAL_CONSENT = gql`
  mutation GrantParentalConsent(
    $childUsername: String!
    $consentMethod: String
  ) {
    grantParentalConsent(
      input: { childUsername: $childUsername, consentMethod: $consentMethod }
    ) {
      success
      errors
      guardianVerified
      consent {
        uuid
        consentMethod
        consentScope
        givenAt
      }
    }
  }
`;

const REVOKE_PARENTAL_CONSENT = gql`
  mutation RevokeParentalConsent(
    $childUsername: String!
    $revocationReason: String
  ) {
    revokeParentalConsent(
      input: {
        childUsername: $childUsername
        revocationReason: $revocationReason
      }
    ) {
      success
      errors
      consent {
        uuid
        revokedAt
        revocationReason
      }
    }
  }
`;

const DELETE_MINOR_ACCOUNT = gql`
  mutation DeleteMinorAccount(
    $childUsername: String!
    $recipientGuardianUsername: String!
  ) {
    deleteMinorAccount(
      input: {
        childUsername: $childUsername
        recipientGuardianUsername: $recipientGuardianUsername
      }
    ) {
      success
      errors
      deletionRecord {
        uuid
        deletedAt
        staffAlertTriggered
      }
    }
  }
`;

const CANCEL_FAMILY_INVITATION = gql`
  mutation CancelFamilyInvitation($token: String!) {
    cancelFamilyInvitation(input: { token: $token }) {
      success
      errors
      familyInvitations {
        token
        isRejected
        cancelledBySender
      }
    }
  }
`;

export {
  ADD_FAMILY_WITH_GUARDIAN,
  FAMILY_INVITATION_RESPONSE,
  INVITE_FAMILY_MEMBERS,
  UPDATE_FAMILY,
  UPDATE_FAMILY_USER,
  UPDATE_CHILD_SETTINGS,
  GRANT_PARENTAL_CONSENT,
  REVOKE_PARENTAL_CONSENT,
  DELETE_MINOR_ACCOUNT,
  CANCEL_FAMILY_INVITATION,
};
